export default __webpack_public_path__ + "static/media/location-basic.e44a57ac.png";